import { combineReducers } from '@reduxjs/toolkit';
import authReducer from '../slices/authSlice';
import commentsReducer from '../slices/commentsSlice';
import reviewReducer from '../slices/reviewSlice';
import type { RootState } from './types';

export const rootReducer = combineReducers({
  auth: authReducer,
  comments: commentsReducer,
  review: reviewReducer,
});

export const persistWhiteList: (keyof RootState)[] = ['auth', 'comments', 'review'];
